// File: src/modules/jobs/EstimateAutocomplete.js

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const AutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SuggestionsList = styled.ul`
  position: absolute;
  top: 100%;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => props.theme.colors.inputGray};
  border-radius: 4px;
  z-index: 10;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const SuggestionItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.background};
  }
`;

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(1)};

  svg {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.inputGray};
  }

  label {
    position: absolute;
    top: 5%;
    left: 45px;
    transform: translateY(-50%);
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.inputGray};
    font-size: 14px;
    transition: all 0.2s ease;
    padding: 0 5px;
    pointer-events: none;
  }

  input {
    width: 100%;
    padding: 25px;
    padding-left: 45px;
    margin: 5px 0;
    font-size: 1.2em;
    border: 1px solid ${(props) => props.theme.colors.inputGray};
    border-radius: 5px;
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.textPrimary};
    outline: none;

    &:focus {
      border-color: ${(props) => props.theme.colors.textPrimary};
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
      color: ${(props) => props.theme.colors.textPrimary};
      font-size: 14px;
    }

    &::placeholder {
      color: ${(props) => props.theme.colors.inputGray};
    }
  }
`;

const EstimateAutocomplete = ({ suggestions, onSelect, onChange, label, placeholder, value }) => {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState(value || '');
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    setInputValue(value ? `${value.Lead.name} - #${value.id}` : '');
  }, [value]);

  const handleInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setInputValue(query);

    if(query.length > 1){
      setFilteredSuggestions(
        suggestions.filter(
          (suggestion) =>
            suggestion.Lead.name.toLowerCase().includes(query) ||
            suggestion.id.toString().includes(query)
        )
      );
      setShowSuggestions(true);
    }else{
      setFilteredSuggestions([]);
      setShowSuggestions(false);
      onChange(query);
    }
  };

  const handleSelect = (suggestion) => {
    setInputValue(`${suggestion.Lead.name} - #${suggestion.id}`);
    setShowSuggestions(false);
    onSelect(suggestion);
  };

  return (
    <AutocompleteWrapper>
      <InputWrapper>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          onFocus={() => setShowSuggestions(true)}
        />
        <label>{label}</label>
      </InputWrapper>
      {showSuggestions && (
        <SuggestionsList>
          {filteredSuggestions.map((suggestion, index) => (
            <SuggestionItem key={index} onClick={() => handleSelect(suggestion)}>
              {suggestion.Lead.name} - #{suggestion.id}
            </SuggestionItem>
          ))}
        </SuggestionsList>
      )}
    </AutocompleteWrapper>
  );
};

export default EstimateAutocomplete;
